import { NameAndMobileOnlyOptions } from "./NameAndMobileOnlyOptions";
import type { LandingPageConfigOptions } from "landing/objects/LandingPageConfig";

export const LandingPageTemplate22: LandingPageConfigOptions = {
  ...NameAndMobileOnlyOptions,
  showsStoreSelector: true,
};
